import React, { Component } from 'react';
import LazarovPic from '../../images/LazarovPic.jpeg';

const largerDivStyle = {
  width: "100%",
  boxSizing: "borderBox",
  margin: "auto",
  paddingTop: "40px",
  paddingBottom: "120px"
};

const imgStyle = {
  float: "left",
  height: "40%",
  width: "22%",
  position: "absolute",
};

const innerDivStyle = {
  float: "right",
  width: "65%",
  paddingBottom: "120px"
};

const textStyle = {
  fontFamily: "'Trebuchet MS', Helvetica, sans-serif",
  textAlign: "justify",
  fontSize: "16px"
};

class LazarovBio extends Component {
  render() {
    return (
      <div style={largerDivStyle}>
        <img src={LazarovPic} style={imgStyle} alt="Lazarov's pic" />
        <div style={innerDivStyle}>
          <p style={textStyle}>
            Dr.Aneta Lazarov is a board certified dermatologist with more than 36 years 
            experience working as consulting dermatologist in hospital settings, in 
            private practice and as a senior lecturer at the university. For the last 12 
            years Dr.Lazarov has been dedicated to the early detection and treatment of 
            skin cancer.In her search for improving the preventive program for her patients 
            Dr.Lazarov started studying and applying the methods of the integrative medicine 
            combining the advances of western medicine and the evidence based complementary 
            and alternative practices including mind body techniques in order to maximize the 
            benefit they bring to the patient in prevention and treatment of illness and 
            promotion of wellbeing and health.
            <br/><br/>
            Her training in this new field includes courses on Unified Integrative 
            Medicine with Dr.Nader Buto Israel, Mind Body Training Program at the CMBM 
            under Dr.James Gordon USA, Bioenergy Domancic Bioenergy Method, Bioergonomy, 
            Recall Healing Gilbet Raunaud PhD, Canada and Energy Medicine Donna Eden USA, 
            She is also a student of Kabbalah for more than 15 years.
            <br/><br/>
            In her practice Dr.Lazarov very successfully applies and teaches the method 
            of integrative preventive medicine based on the understanding that our 
            wellbeing and health are achieved by promoting wellness at all levels 
            including the physical, mental, emotional, social, energy and spiritual 
            levels.
          </p>
        </div>
      </div>
    )
  }
}

export default LazarovBio;